export default __webpack_public_path__ + "static/media/Image.14c0693f.png";